const actions = {
  SET_LANGUAGE: 'localization/SET_LANGUAGE'
};

export default actions;
